export type Countdown = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  totalMs: number;
};

export function nextBirthday(now: Date = new Date()): Date {
  const year = now.getFullYear();
  const thisYear = new Date(year, 10, 28, 0, 0, 0, 0); // month is 0-indexed, 10 = November
  if (now.getTime() < thisYear.getTime()) return thisYear;
  return new Date(year + 1, 10, 28, 0, 0, 0, 0);
}

export function endOfBirthday(now: Date = new Date()): Date {
  const year = now.getFullYear();
  return new Date(year, 10, 28, 23, 59, 59, 999);
}

export function isBirthdayToday(now: Date = new Date()): boolean {
  return now.getMonth() === 10 && now.getDate() === 28;
}

export function getCountdown(now: Date = new Date()): Countdown {
  const target = nextBirthday(now);
  const ms = Math.max(0, target.getTime() - now.getTime());
  const days = Math.floor(ms / 86_400_000);
  const hours = Math.floor((ms % 86_400_000) / 3_600_000);
  const minutes = Math.floor((ms % 3_600_000) / 60_000);
  const seconds = Math.floor((ms % 60_000) / 1000);
  return { days, hours, minutes, seconds, totalMs: ms };
}

// Stable per-day seed: YYYYMMDD as a number, in local time.
export function localDayKey(now: Date = new Date()): number {
  return (
    now.getFullYear() * 10000 +
    (now.getMonth() + 1) * 100 +
    now.getDate()
  );
}

// 1..13 — different offset from effect so they don't change in lockstep.
export function dailyImageNumber(now: Date = new Date()): number {
  return (((localDayKey(now) + 7) % 13) + 13) % 13 + 1;
}

export function dailyImageUrl(now: Date = new Date()): string {
  return `/assets/${dailyImageNumber(now)}.webp`;
}
